import type { Node, ResolvedPos } from "@tiptap/pm/model";

/**
 * Result of walking up a resolved position to find a cell and its parent row.
 */
export interface CellRowContext {
  cellDepth: number;
  rowDepth: number;
  cellNode: Node;
  rowNode: Node;
}

/**
 * Walk up from a resolved position to find the enclosing emailCell and emailRow.
 * Returns null if the position is not inside a cell/row structure.
 */
export function findCellAndRow($pos: ResolvedPos): CellRowContext | null {
  let cellDepth = -1;
  let rowDepth = -1;
  for (let d = $pos.depth; d >= 0; d--) {
    const name = $pos.node(d).type.name;
    if (name === "emailCell" && cellDepth < 0) {
      cellDepth = d;
    }
    if (name === "emailRow") {
      rowDepth = d;
      break;
    }
  }
  if (rowDepth < 0 || cellDepth < 0) return null;

  return {
    cellDepth,
    rowDepth,
    cellNode: $pos.node(cellDepth),
    rowNode: $pos.node(rowDepth),
  };
}

/**
 * A cell's position and node within a row, collected via collectRowCells.
 */
export interface CellInfo {
  pos: number;
  node: Node;
}

/**
 * Collect all cells in a row with their absolute document positions.
 * `rowStart` is the position at the start of the row's content (from `$pos.start(rowDepth)`).
 */
export function collectRowCells(rowNode: Node, rowStart: number): CellInfo[] {
  const cells: CellInfo[] = [];
  rowNode.forEach((child, offset) => {
    cells.push({ pos: rowStart + offset, node: child });
  });
  return cells;
}
